export default {
  dbu_content_management_center_title: 'Content Management Center',
  dbu_content_management_center_subtitle: 'Upload, edit, and manage your game data insight reports',
};
